import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function throttle(callback, wait, immediate = false) {
  let timeout = null
  let initialCall = true

  return (...args) => {
    const callNow = immediate && initialCall
    const next = () => {
      callback.apply(this, ...args)
      timeout = null
    }

    if (callNow) {
      initialCall = false
      next()
    }

    if (!timeout) {
      timeout = setTimeout(next, wait)
    }
  }
}

export function debounce(fn, ms) {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => fn(...args), ms)
  }
}

export function createEvent(name) {
  if (typeof Event === 'function') {
    return new Event(name)
  }

  const event = document.createEvent('Event')
  event.initEvent(name, true, true)
  return event
}

export const getMousePos = e => {
  let posx = 0
  let posy = 0
  if (!e) e = window.event
  if (e.pageX || e.pageY) {
    posx = e.pageX
    posy = e.pageY
  } else if (e.clientX || e.clientY) {
    posx =
      e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft
    posy =
      e.clientY + document.body.scrollTop + document.documentElement.scrollTop
  }

  return { x: posx, y: posy }
}

export function isSwiperInitialize(element) {
  return element.classList.contains('swiper-container-initialized')
}

export const isInViewport = elem => {
  const distance = elem.getBoundingClientRect()
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  )
}

export const normalizeArrayData = (array, slice) => {
  const res = []

  for (let i = 0; i < array.length; i += slice) {
    const partArr = array.slice(i, i + slice)
    res.push(partArr.reduce((a, c) => a + c, 0) / partArr.length)
  }

  return res
}

export const isVisible = element =>
  element.offsetWidth > 0 && element.offsetHeight > 0

export const isValidSelector = (container, selector) => {
  try {
    container.querySelector(selector)
  } catch (e) {
    return false
  }

  return true
}

export const refreshScrollTrigger = throttle(() => {
  ScrollTrigger.refresh()
}, 100)
